export const VISIT_NOTE_TEMPLATE_ACTION = {
  VIEW: "view",
  EDIT: "edit",
  ARCHIVE: "archive",
} as const;

export const VISIT_NOTE_TEMPLATE_ACTION_LABEL = {
  VIEW: "View",
  EDIT: "Edit",
  ARCHIVE: "Archive",
  UNARCHIVE: "Unarchive",
} as const;

export const SHOW_ARCHIVED_TEMPLATES_LABEL = "Show Archived Templates";

export const VISIT_NOTE_TEMPLATE_ARCHIVE_CONFIRMATION =
  "You want to archive this Visit Note Template?";

export const VISIT_NOTE_TEMPLATE_UNARCHIVE_CONFIRMATION =
  "You want to unarchive this Visit Note Template?";
